import {
  SELECT_SERVICE,
  SERVICE_CREATE_REQUEST_FAIL,
  SERVICE_CREATE_REQUEST_SUCCESS,
  SERVICE_FIND_REQUEST_FAIL,
  SERVICE_FIND_REQUEST_SUCCESS,
  SERVICE_UPDATE_REQUEST_FAIL,
  SERVICE_UPDATE_REQUEST_SUCCESS
} from "../action.types";
import initialValue from "../initial.state";

export default function(state = initialValue.service, action) {
  switch (action.type) {
    case SELECT_SERVICE:
      return { ...action.service };
    case SERVICE_CREATE_REQUEST_SUCCESS:
      return state;
    case SERVICE_CREATE_REQUEST_FAIL:
      return state;
    case SERVICE_UPDATE_REQUEST_SUCCESS:
      return state;
    case SERVICE_UPDATE_REQUEST_FAIL:
      return state;
    case SERVICE_FIND_REQUEST_SUCCESS:
      return { ...action.payload };
    case SERVICE_FIND_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/service/service.reducer.js